import {NgModule} from '@angular/core';
import {provideConfig, provideDefaultConfig} from '@spartacus/core';
import {defaultDtrumConfig} from '@app/personalization/tracking/config/default-dtrum.config';
import {AepModule} from '@spartacus/tracking/tms/aep';
import {BaseTmsModule, TmsConfig} from '@spartacus/tracking/tms/core';
import {GtmModule} from '@spartacus/tracking/tms/gtm';

@NgModule({
  declarations: [],
  imports: [BaseTmsModule.forRoot(), AepModule, GtmModule],
  providers: [
    provideDefaultConfig(defaultDtrumConfig),
    provideConfig({
      tagManager: {
        aep: {
          events: [],
        },
      },
    } as TmsConfig),
    provideConfig({
      tagManager: {
        gtm: {
          events: [],
        },
      },
    } as TmsConfig),
  ],
})
export class TagManagementFeatureModule {}
